<template>
	<ul class='deal__counts'>
		<li class='deal__count' v-if='deal.apartments'>
			<svg class='icon'>
				<use xlink:href='#icon-apts' />
			</svg>
			<div class='deal__count-label'>
				<span class='deal__count-size'>
					{{ deal.apartments }}
				</span>
				<small class='deal__count-title'>
					Apts
				</small>
			</div>
		</li>
		<li class='deal__count' v-if='deal.bedrooms'>
			<svg class='icon'>
				<use xlink:href='#icon-bed' />
			</svg>
			<div class='deal__count-label'>
				<span class='deal__count-size'>
					{{ deal.bedrooms }}
				</span>
				<small class='deal__count-title'>
					Beds
				</small>
			</div>
		</li>
		<li class='deal__count' v-if='deal.bathrooms'>
			<svg class='icon'>
				<use xlink:href='#icon-bath' />
			</svg>
			<div class='deal__count-label'>
				<span class='deal__count-size'>
					{{ deal.bathrooms }}
				</span>
				<small class='deal__count-title'>
					Baths
				</small>
			</div>
		</li>
		<li class='deal__count' v-if='deal.sqft'>
			<svg class='icon'>
				<use xlink:href='#icon-sqft' />
			</svg>
			<div class='deal__count-label'>
				<span class='deal__count-size'>
					{{ deal.sqft }}
				</span>
				<small class='deal__count-title'>
					Sqft
				</small>
			</div>
		</li>
	</ul>
</template>

<script>
export default {
	name:       'DealCounts',
	props:     ['deal'],
};
</script>
